import {fork} from 'child_process'
import {cpus} from 'os'

const workers = []
const tasks = {}
const workerNumber = cpus().length
for (let i = 0; i < workerNumber; ++i) {
	const w = fork(__dirname + '/worker-entry')
	w.on('message', ({id, command, result, error, time}) => {
		console.log(command + ' task ' + id + ': ' + time + 'ms')
		console.timeEnd(command + ' task ' + id)
		const [resolve, reject] = tasks[id]
		if (error !== undefined) reject(error)
		else resolve(result)
		delete tasks[id]
	})
	workers.push(w)
}

let id = 0x10000
const _execute = (command, args) => new Promise(
	(resolve, reject) => {
		tasks[id] = [resolve, reject]
		console.time(command + ' task ' + id)
		const n = id % workers.length
		console.log('send', command, 'task', id, 'to worker', n)
		workers[n].send({id, command, args})
		++id
	}
)

import sha1 from './sha1'
let _cache = {}
export const execute = (command, args) => {
	const k = command + ':' + JSON.stringify(args)::sha1()
	if (_cache[k]) return _cache[k]
	return _cache[k] = _execute(command, args)
}

import {readFileSync, writeFileSync} from 'fs'
export const saveCache = filename => writeFileSync(filename, JSON.stringify(_cache), 'utf-8')
export const loadCache = filename => _cache = JSON.parse(readFileSync(filename, 'utf-8'))
